import { createRoute } from "@tanstack/react-router";
import GenerationPageLayout from "@/layouts/pages/generationPageLayout/GenerationPageLayout";
import GenerationPage from "@/views/generation/GenerationPage";
import { fetchAICBQGenerationAll } from "@/apis/naniexpert/services/aiCompetencyBasedQuestionGeneration";
import { Route } from "./__root";

export const indexRoute = createRoute({
  getParentRoute: () => Route,
  path: "/",
  beforeLoad: async () => {
    try {
      const data = await fetchAICBQGenerationAll();
      if (!data.eduContent?.length) {
        return { generationDataError: true };
      }
      return { generationData: data };
    } catch {
      return { generationDataError: true };
    }
  },
  loader: ({ context }) => context.generationData ?? null,
  component: () => (
    <GenerationPageLayout>
      <GenerationPage />
    </GenerationPageLayout>
  ),
});
